import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations } from 'vuexfire'

import clientsModule from './modules/clients'
import bannerModule from './modules/banners'
import layoutModule from './modules/layouts'
import subServicesModule from './modules/subServices'
import mainCategoryModule from './modules/mainCategory'

Vue.use(Vuex)

export default new Vuex.Store({
  mutations: {
    ...vuexfireMutations
  },
  modules: {
    clientsModule,
    bannerModule,
    layoutModule,
    subServicesModule,
    mainCategoryModule
  }
})
